import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";

import { FileData } from '../../core/models/filedata.model';
import { LegalFrameworkPageService, LegalFrameworkPage } from '../shared';
import { KeyValuePipe } from './../../pipes/keyvalue_pipe';

@Component({
  selector: 'bp-legal-framework',
  templateUrl: 'lf-page.component.html'
})

export class LegalFrameworkPageComponent implements OnInit, OnDestroy {

  page: LegalFrameworkPage;
  fullMainHtml: any;
  id: number;

  constructor(
    private legalFrameworkPageService: LegalFrameworkPageService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.route
      .params
      .map(params => params['id'])
      .do(id => this.id = +id)
      .subscribe(id => {
        if (this.id) {
          this.page = null;
          this.fullMainHtml = null;

          this.getLegalFrameworkPage();

        } else {

        }

      });

    this.getLegalFrameworkPage();
  }


  ngOnDestroy(): void {

  }

  getLegalFrameworkPage() {
    this.legalFrameworkPageService.getLegalFramework(this.id)
      .subscribe(page => {
       // console.log('page', page);
        this.page = page;
        this.fullMainHtml = this.sanitizer.bypassSecurityTrustHtml(this.page.mainText);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/legal-framework/lf-page/lf-page.component.ts